import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCollapsible]'
})
export class CollapsibleDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    ($(this.elementRef.nativeElement) as any).collapsible();
  }

}
